// extracted by mini-css-extract-plugin
module.exports = {"b5j5n6l":"b5j5n6l"};